module.exports = __webpack_public_path__ + "static/media/evenings_1.38c6e66b.png";